export default [
    {
      path: '/store-detail',
      name: 'store-detail',
      meta: { title: '门店详情', auth: true, deepth: 2 },
      component: () => import('../../views/store/store-detail.vue')
    }
  ];